import styled from 'styled-components';

export const LatestNewsLeft = styled.div`
`; 

export const StateSelection = styled.div`
    background: rgba(247, 147, 30, 0.1);
    padding: 30px;
    border-radius: 10px;
    height: 100%;

    @media screen and (max-width:767px) {
        padding: 20px;
    }
`;

export const AllState = styled.div`
    display: flex;
    align-items: center;
    column-gap: 20px;
    margin-bottom: 20px;
    @media screen and (max-width:575px) {
        flex-wrap: wrap;
        row-gap: 20px;
    }
`;

export const AllStateTitle = styled.div``;

export const StateName = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px;
    cursor: pointer;
`;

export const StateChange = styled.div`
    background: #555555;
    border-radius: 10px;
    padding: 16px 30px;
    display: flex;
    align-items: center;
    column-gap: 8px;

    @media screen and (max-width:1199px) {
        padding: 13px 11px;
    }
    @media screen and (max-width:575px) {
        padding: 12px 25px;
    }
`;
export const StateChangeName = styled.span`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
    cursor: pointer;
`;

export const AllStateBtn = styled.div`
`;

export const StateBtnTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 26px;
    margin-bottom: 12px;
`;
export const ButtonGroupCity = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    button{
        background-color: #FFFFFF;
        border-radius: 10px;
        border: none;
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 26px;
        appearance: none;
        
        &:active{
            background-color: #01606F !important;
            color: #fff !important;
        }
        &:hover,
        &:focus{
           background-color: #01606F !important;
            color: #fff !important;
        }
    }

    .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
     background-color: #01606F !important;
            color: #fff !important;
    }

    form .input-group input[type=number]{
         -webkit-appearance: none;
    }
    &.form-control{
        appearance: none;
    }
`;
export const LatestNewsRight = styled.div`
`;
